<div fxLayout="column" fxFlexFill *ngIf="!loader">

    <div class="divider layout-padd-2" ngClass.xs="layout-padd-5">
        <span class="mat-title">{{"myaddresses" | translate}}</span>
    </div>

    <div fxLayout="column" fxFlex fxLayoutGap="20px" class="scrolled layout-padd light-grey">
        <mat-card>
            <app-addresses-backoffice-client [clientAddresses$]="clientAddresses$" (setAddressesEvent)="setAddresses($event)">
            </app-addresses-backoffice-client>
        </mat-card>
    </div>

</div>

<!--
<app-popup-loader [flagLoading]="loader" [size]="30" [statusMessage]="'loaderMyaddresses' | translate">
</app-popup-loader>-->
